import { render, staticRenderFns } from "./COM_Footer.vue?vue&type=template&id=4b27b2b2&"
import script from "./COM_Footer.vue?vue&type=script&lang=js&"
export * from "./COM_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports